<template>
  <div>
    <section>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell">
          <h2>Interessante Messen</h2>
        </div>
        <div class="o-grid__cell top-buttons">
          <bos-button @click="newFairWall">Neue Messe</bos-button>
        </div>
      </div>
      <bos-overview-table
        :data="fairWallEntries"
        :columns="[
          {
            key: 'displayName',
            name: 'Name'
          }
        ]"
        deleteTitle="Interessante Messe löschen"
        :deleteText="
          obj =>
            'Soll die Messe <b>&quot;' +
            obj.displayName +
            '&quot;</b> wirklich gelöscht werden?'
        "
        :onEdit="editFairWall"
        :onDelete="deleteFairWall"
      />
    </section>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService'
import BosButton from '@/components/BosButton'
import BosOverviewTable from '@/components/BosOverviewTable'

export default {
  name: 'AdminBegin',
  components: { BosButton, BosOverviewTable },
  data() {
    return {
      fairWallEntries: []
    }
  },
  methods: {
    newFairWall: function() {
      this.$router.push({
        name: 'AdminAdvertisingFairWallCreate'
      })
    },
    editFairWall: function(fairWall) {
      this.$router.push({
        name: 'AdminAdvertisingFairWallEdit',
        params: {
          id: fairWall._id
        }
      })
    },
    deleteFairWall: function(fairWall) {
      ApiService.deleteFairWallEntry(fairWall._id).then(() => {
        this.fairWallEntries = this.fairWallEntries.filter(item => {
          return item._id != fairWall._id
        })
      })
    },
    getFairWallListing() {
      ApiService.getFairWallEntries().then(response => {
        this.fairWallEntries = response.data
      })
    }
  },
  mounted() {
    this.getFairWallListing()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

section {
  margin-bottom: 6rem;
}

.top-buttons {
  float: right;
  text-align: right;
  padding-top: 20px;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
